export default "__VITE_ASSET__1fa0d166__"